import script from "./ShareModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareModal.vue?vue&type=script&setup=true&lang=js"

import "./ShareModal.vue?vue&type=style&index=0&id=efe883d2&lang=scss"

const __exports__ = script;

export default __exports__